import React, { useState } from 'react';

import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { useStyles } from './styles/styles';
import { useSelector } from 'react-redux';
import Toolbar from "@mui/material/Toolbar";

import PaymentPlanList from './pages/PaymentPlanList';
import Webhooks from './pages/Webhooks';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Ticket from './pages/Ticket';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

export default function PaymentPlan(){
  const classes = useStyles();
  const isAdmin = useSelector(({ User }) => User?.admin);
  const location = useLocation();
  const state = location.state;
  const [currentTab, setCurrentTab] = useState(state?.tab || 0);

  const handleChange = (_, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <>
        <Container className={classes.main} maxWidth="xl">
            <AppBar position="static">
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Tabs value={currentTab} onChange={handleChange}>
                    <Tab label="Planos de Pagamento" {...a11yProps(0)} />
                    <Tab label="Boletos" {...a11yProps(1)} />
                    {isAdmin && <Tab label="Webhook" {...a11yProps(2)} />}
                </Tabs>
                </Toolbar>
            </AppBar>

            <TabPanel value={currentTab} index={0}>
                <PaymentPlanList />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
                <Ticket />
            </TabPanel>
            <TabPanel value={currentTab} index={2}>
                <Webhooks />
            </TabPanel>
        </Container>
    </>
  )
}
